module.exports = __webpack_public_path__ + "media/images/favicon-06fb53c9b96426c0fb0226da19be221a.ico";